<template>
  <div id="transactions">
    <div class="padding-top-5"></div>
    <div class="gift-card margin-10">
      <div class="box-shadow" v-if="giftCards.length">
        <div class="align-hor center-ver space-between bottom-border bg-light padding-10 pointer" v-on:click="redirectTo('gift-cards/'+gc.id)" v-for="gc in giftCards" v-if="gc.is_active">
          <div class="align-hor center-ver">
            <div class="w20 gift-card-image margin-right-10">
              <div v-if="gc.image_url">
                <img  class="full-width gift-card-image radius-5" :src="gc.image_url">
              </div>
              <div class="dummy full-width bg-light-grey radius-5" v-else></div>
            </div>
            <div class="text-left">
              <div class="margin-bottom-5 text-regular text-light-grey">{{gc.name}}</div>
              <div class="text-semi-small text-light-grey">Value: <span class="font-bold text-dark">₹{{gc.value}}</span></div>
            </div>
          </div>
          <div class="wrap align-hor center-ver center-hor padding-5 radius-3 text-small pointer" @click.stop.prevent="toggleGiftModal(true, gc)" :style="{border: '1px solid '+bgTheme}">
            <img class="smaller-icon pull-left margin-right-5" :src="userHeaderBalance.icon"> {{gc.currency_req}}
          </div>
          <gift-popup v-if="gc.show_popup"></gift-popup>
        </div>
      </div>
      <div class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver" style="min-height: 70vh" v-else>
        <img class="extra-large-icon margin-bottom-20" src="@/assets/no-data.svg">
        <div class="margin-bottom-20">Nothing to Show</div>
      </div>

      <div class="bg-light box-shadow" v-if="giftCards.length == 0 && showShimmer" v-for="$i in 3">
        <div class="align-hor center-ver space-between padding-10 bottom-border">
          <div class="w70">
            <div class="align-hor center-ver">
              <div class="w20 margin-right-10">
                <div class="wrapper">
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
              <div class="w40">
                <div class="wrapper">
                  <div class="comment animate margin-bottom-5 w85"></div>
                  <div class="comment animate w50"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="w15">
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import GiftCardPopup from '@/components/gift-card-popup'
  export default {
    mixins: [globals],
    components: {
      'gift-popup': GiftCardPopup
    },
    data() {
      return {
        giftCards: [],
        is_shimmer: true
      }
    },
    beforeMount() {
      this.loadDataFromCookie();
    },
    computed: {
      showShimmer: function() {
        return this.is_shimmer;
      }
    },
    methods: {
      fetchGiftCards: function() {
        var url = this.$store.getters.flyyDomain+'/gift_cards';
        var headers = this.$store.getters.headers;
        axios.get(url, {
          mode: 'no-cors',
          headers: headers
        }).then((resp) => {
          var all_gift_cards = resp.data.gift_cards;
          var tempArr = [];
          if(all_gift_cards && all_gift_cards.length > 0) {
            all_gift_cards.forEach((gc) => {
              tempArr.push({
                id: gc.id,
                value: gc.value,
                is_active: gc.is_active,
                sku: gc.sku,
                name: gc.name,
                description: gc.description,
                image_url: gc.image_url,
                tnc_content: gc.tnc_content,
                expiry: gc.expiry,
                currency_req: gc.currency_req,
                currency_label: gc.currency_label,
                show_popup: false
              })
            })
          }
          this.giftCards = tempArr;
          this.is_shimmer = false;
        });
      }
    },
    created() {
      var store_state = this.$store.state;
      store_state.showHeader = true;
      store_state.showWallet = false;
      store_state.showHistory = false;
      store_state.headTitle = "Gift Cards";
      store_state.user.headerBalance.show = true;
      this.loadDataFromCookie();
      this.fetchGiftCards();
    }
  }
</script>
<style>
  .card-details {
    height: 250px;
    margin: auto 10px;
  }
  .gift-card .wrap {
    min-width: 55px;
  }
  .gift-card-image {
    min-width: 50px;
  }
  .gift-card-image .dummy {
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/gift-cards.vue